export default function devConsole(
  message?: any,
  ...optionalParams: any[]
): void {
  if (process.env.NODE_ENV !== 'development') {
    return;
  }

  const checkType = (x: any): boolean => {
    return (
      typeof x === 'boolean' || typeof x === 'string' || typeof x === 'number'
    );
  };

  if (
    checkType(message) &&
    Array.from(optionalParams).every((i) => checkType(i))
  ) {
    // eslint-disable-next-line no-console
    console.log(
      `%c${message} ${Array.from(optionalParams).join('')}`,
      'color: #bada55'
    );
  } else {
    // eslint-disable-next-line no-console
    console.log(message, ...optionalParams);
  }
}
